import { css } from "styled-components/macro";

import {
  producingColor,
  textOnProducing,
  plannedColor,
  textOnPlanned,
  waitingColor,
  textOnWaiting,
  untaggedColor,
  textOnUnknown,
  noProductionScheduledColor,
  textOnNotScheduled,
  plantLossColor,
  textOnPlant,
  uncollectedColor,
  textOnUncollected,
  medGrey,
  unplannedColor,
  textOnUnplanned,
} from "../../../../constants/colors";

export const PNL_COLORS_CSS = css`
  &.details-process-producing,
  .background-producing {
    background-color: ${producingColor};
    color: ${textOnProducing};
    fill: ${textOnProducing};
    stroke: ${textOnProducing};
  }
  &.details-process-planned,
  .background-planned {
    background-color: ${plannedColor};
    color: ${textOnPlanned};
    fill: ${textOnPlanned};
    stroke: ${textOnPlanned};
  }
  &.details-process-waiting,
  .background-waiting {
    background-color: ${waitingColor};
    color: ${textOnWaiting};
    fill: ${textOnWaiting};
    stroke: ${textOnWaiting};
  }
  &.details-process-unplanned,
  .background-unplanned {
    background-color: ${unplannedColor};
    color: ${textOnUnplanned};
    fill: ${textOnUnplanned};
    stroke: ${textOnUnplanned};
  }
  &.details-process-untagged,
  .background-untagged,
  &.details-process-unknown,
  .background-unknown {
    background-color: ${untaggedColor};
    color: ${textOnUnknown};
    fill: ${textOnUnknown};
    stroke: ${textOnUnknown};
  }
  &.details-process-notScheduled,
  .background-notScheduled {
    background-color: ${noProductionScheduledColor};
    color: ${textOnNotScheduled};
    fill: ${textOnNotScheduled};
    stroke: ${textOnNotScheduled};
  }
  &.details-process-plantLoss,
  .background-plantLoss {
    background-color: ${plantLossColor};
    color: ${textOnPlant};
    fill: ${textOnPlant};
    stroke: ${textOnPlant};
  }
  &.details-process-uncollected,
  .background-uncollected {
    background-color: ${uncollectedColor};
    color: ${textOnUncollected};
    fill: ${textOnUncollected};
    stroke: ${textOnUncollected};
  }
  &.details-process-loading,
  .background-loading {
    background-color: #ffffff;
    color: ${medGrey};
    fill: ${medGrey};
    stroke: ${medGrey};
    border: 1px solid ${medGrey};
  }
`;
